/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Error_MaintenanceInputs */

const en_backend_session_error_maintenance = /** @type {(inputs: Backend_Session_Error_MaintenanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service in maintenance, please retry in a few minutes.`)
};

const fr_backend_session_error_maintenance = /** @type {(inputs: Backend_Session_Error_MaintenanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service en maintenance, retentez dans quelques minutes.`)
};

const ms_sg2_backend_session_error_maintenance = /** @type {(inputs: Backend_Session_Error_MaintenanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perkhidmatan dalam penyelenggaraan, sila cuba semula dalam beberapa minit.`)
};

/**
* | output |
* | --- |
* | "Service in maintenance, please retry in a few minutes." |
*
* @param {Backend_Session_Error_MaintenanceInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_maintenance = /** @type {((inputs?: Backend_Session_Error_MaintenanceInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_MaintenanceInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_maintenance(inputs)
	if (locale === "fr") return fr_backend_session_error_maintenance(inputs)
	return ms_sg2_backend_session_error_maintenance(inputs)
});